import * as Yup from 'yup';

export type ActionType = 'add-comment' | 'add-user-action' | 'mark-completed';

type AddCommentAction = {
  action: 'add-comment';
  addCommentData: { comment: string };
};

type AddUserActionAction = {
  action: 'add-user-action';
};

type MarkCompletedAction = {
  action: 'mark-completed';
};

export type FormValues = AddCommentAction | AddUserActionAction | MarkCompletedAction;

export type ActionDataType<T extends ActionType> = Extract<FormValues, { action: T }>;

const addCommentSchema = Yup.object().shape({
  action: Yup.string().oneOf(['add-comment']).required(),
  addCommentData: Yup.object()
    .shape({
      comment: Yup.string().trim().required('Required').max(1000, 'Cannot exceed 1000 characters'),
    })
    .required(),
});

const addUserActionSchema = Yup.object().shape({
  action: Yup.string().oneOf(['add-user-action']).required(),
  addUserActionData: Yup.object().shape({}).required(),
});

const markCompletedSchema = Yup.object().shape({
  action: Yup.string().oneOf(['mark-completed']).required(),
  markCompletedData: Yup.object().shape({}).required(),
});

// Helper function to get validation schema based on action type
export const getValidationSchemaForAction = (action: ActionType): Yup.ObjectSchema<any> => {
  switch (action) {
    case 'add-comment':
      return addCommentSchema;
    case 'add-user-action':
      return addUserActionSchema;
    case 'mark-completed':
      return markCompletedSchema;
    default:
      return addCommentSchema;
  }
};

export const getInitialValuesForAction = (action: ActionType, initialValues?: Partial<FormValues>): FormValues => {
  const getDefaults = (action: ActionType): FormValues => {
    switch (action) {
      case 'add-comment':
        return {
          action: 'add-comment',
          addCommentData: { comment: '' },
        };
      case 'add-user-action':
        return {
          action: 'add-user-action',
        };
      case 'mark-completed':
        return {
          action: 'mark-completed',
        };
      default:
        return {
          action: 'add-comment',
          addCommentData: { comment: '' },
        };
    }
  };

  const defaults = getDefaults(action);

  if (initialValues && initialValues.action === action) {
    return { ...defaults, ...initialValues } as FormValues;
  }

  return defaults;
};

export const options: { label: string; value: ActionType }[] = [
  {
    label: 'Add a comment',
    value: 'add-comment',
  },
  // {
  //   label: 'Add a user action',
  //   value: 'add-user-action',
  // },
  // {
  //   label: 'Mark an action as completed',
  //   value: 'mark-completed',
  // },
];
